import { Image, useMantineTheme, type StyleProp } from "@mantine/core";

import { LAYOUT_HEADER_HEIGHT } from "@/configs/layout";
import { useEnv } from "@/hooks/useEnv";
import { isDefined } from "@/utils/format";

interface AppLogoProps {
  height?: StyleProp<React.CSSProperties["height"]>;
}
export const AppLogo = ({ height = LAYOUT_HEADER_HEIGHT }: AppLogoProps) => {
  const theme = useMantineTheme();
  const supabaseUrl = useEnv("VITE_SUPABASE_URL");
  const logo =
    isDefined(supabaseUrl) && isDefined(theme.other.logo) ? supabaseUrl + theme.other.logo : theme.other.logoLocal;
  return <Image src={logo} h={height} w="auto" p="sm" />;
};

export default AppLogo;
